import type { BlockSerializedChild } from '#layers/block-engine/types/block';
import { useBlockEditorContext } from '#layers/block-engine/composables/use-block-editor-context';

export function useHandleBlockClick() {
	const { drag, selection, insertion } = useBlockEditorContext();

	function onBlockClick(event: MouseEvent, child: BlockSerializedChild) {
		if (!drag.dragging.value) {
			if (event.ctrlKey) {
				selection.toggle(child.id);
			}
			else {
				selection.selectedChildIds.value = [child.id];
			}

			insertion.clear();

			event.stopPropagation();
		}
	}

	return {
		onBlockClick,
	};
}
